import instance from "../services/request";

const API_ENDPOINT = "/api/presigned-url/";

const slugifyFilename = (filename) => {
  return filename
    .replace(/[^a-zA-Z0-9.]/g, "-") // Replace special characters with hyphens
    .replace(/-+/g, "-") // Remove duplicate hyphens
    .toLowerCase(); // Convert to lowercase
};

export const getPresignedUrl = async (fileKey, fileSize) => {
  try {
    const response = await instance.post(API_ENDPOINT, {
      object_path: fileKey,
      object_size: fileSize,
    });
    if (response.status === 200) {
      return response.data.data;
    } else {
      throw new Error(response.data.message || "Failed to get pre-signed URL");
    }
  } catch (error) {
    console.error("Error fetching pre-signed URL:", error);
    throw error;
  }
};

export const uploadFile = async (file, folderStructure) => {
  const sanitizedFileName = slugifyFilename(file.name);
  const fileName = sanitizedFileName;
  const fileKey = `${folderStructure}${fileName}`;

  try {
    // Get pre-signed URL from backend
    const { presigned_url, object_url } = await getPresignedUrl(
      fileKey,
      file.size
    );

    // Upload file to S3 via pre-signed URL
    const uploadResponse = await fetch(presigned_url, {
      method: "PUT",
      body: file,
      mode: "cors",
      headers: {
        "x-amz-acl": "public-read",
      },
    });

    if (!uploadResponse.ok) {
      throw new Error(
        `Upload failed: ${uploadResponse.status} ${uploadResponse.statusText}`
      );
    }

    return { location: object_url, fileKey, fileType: file.type };
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};
